// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "../../../../../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import ReactMarkdown from "react-markdown";
import * as AuthStore$PorterinFeature from "../../../domain/store/AuthStore.mjs";
import * as AuthUtils$PorterinFeature from "../../../domain/helpers/AuthUtils.mjs";
import * as CityContext$PorterinFeature from "../../../../../contexts/city-context/CityContext.mjs";
import * as AuthContextV1$PorterinFeature from "../../../view-model/contexts/auth-context/AuthContextV1.mjs";
import * as PublishEventsHelper$PorterinFeature from "../../../../../shared/core/helpers/PublishEventsHelper.mjs";
import * as ChangeOtpNumberModuleScss from "../../styles/ChangeOtpNumber.module.scss";

var styles = ChangeOtpNumberModuleScss;

function ChangeOtpNumberCmp(Props) {
  var set_auth_state = Props.set_auth_state;
  var match = CityContext$PorterinFeature.useCitySelectedContext(undefined);
  var category = match.category;
  var match$1 = AuthContextV1$PorterinFeature.useAuthContext(undefined);
  var mobile = AuthUtils$PorterinFeature.mobile(match$1.user);
  return React.createElement("div", {
              className: styles["change-number"]
            }, React.createElement(ReactMarkdown, {
                  children: AuthStore$PorterinFeature.OtpValidation.sub_heading
                }), React.createElement("div", {
                  className: styles.number
                }, React.createElement("p", {
                      className: styles["user-number"]
                    }, "(+91) " + mobile + "."), React.createElement("p", {
                      className: styles["change-button"],
                      onClick: (function (param) {
                          Curry._1(set_auth_state, (function (param) {
                                  return /* LoginScreen */{
                                          _0: undefined,
                                          _1: false
                                        };
                                }));
                          PublishEventsHelper$PorterinFeature.publishEvents(category, AuthStore$PorterinFeature.OtpValidation.ga_change_number, undefined);
                        })
                    }, AuthStore$PorterinFeature.OtpValidation.change_number)));
}

var make = ChangeOtpNumberCmp;

export {
  styles ,
  make ,
}
/* styles Not a pure module */
